import { render, staticRenderFns } from "./CustomOfficialEvents1.vue?vue&type=template&id=3a0cb90f&scoped=true"
import script from "./CustomOfficialEvents1.vue?vue&type=script&lang=js"
export * from "./CustomOfficialEvents1.vue?vue&type=script&lang=js"
import style0 from "./CustomOfficialEvents1.vue?vue&type=style&index=0&id=3a0cb90f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0cb90f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a0cb90f')) {
      api.createRecord('3a0cb90f', component.options)
    } else {
      api.reload('3a0cb90f', component.options)
    }
    module.hot.accept("./CustomOfficialEvents1.vue?vue&type=template&id=3a0cb90f&scoped=true", function () {
      api.rerender('3a0cb90f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/CustomOfficialEvents1.vue"
export default component.exports